export const ERROR_TYPES = {
  EXPIRED: 'expired',
  INVALID: 'invalid',
  NETWORK: 'network',
}
